import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
    FNDY_STORAGE_SERVICE,
    FoundryApiModule,
    IFoundryApiConfigModel,
} from '@thinglogix/ngx-foundry-core';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CookieStorageService } from './core/cookie-storage.service';
import { SensorsService } from './sensors/services/sensors.service';
import { AttributeFormatPipe } from './shared/attribute-format.pipe';
import { SkusService } from './skus/services/skus.service';
import { NgChartsModule } from 'ng2-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

const config: IFoundryApiConfigModel = {
    rootApi: {
        foundryApiEndpoint: environment.fndyApiGatewayEndpoint,
        foundryApiKey: environment.fndySecureApiGatewayKey,
    },
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        FormsModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FoundryApiModule.forRoot(config),
        NgChartsModule,
        BrowserAnimationsModule,
    ],
    providers: [
        SensorsService,
        SkusService,
        AttributeFormatPipe,
        { provide: FNDY_STORAGE_SERVICE, useClass: CookieStorageService },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
